import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import {
    getAwaitingRatings,
    getMyReceivedRatings,
    getTicketRatingView,
    submitTicketRating,
} from '../services'
import {
    AwaitingRatingFilters,
    ReceivedRatingFilters,
    SubmitRatingPayload,
} from '../types'

// GET context + rating hiện có cho dialog ?rate=1 (chỉ fetch khi mở dialog).
export const useTicketRatingView = (ticketId: number, enabled = true) =>
    useQueryWithHandler({
        queryKey: [QUERY_KEYS.RATINGS_TICKET, ticketId],
        queryFn: () => getTicketRatingView(ticketId),
        enabled: enabled && ticketId > 0,
    })

// Submit rating; invalidate view + tab awaiting + tab received.
export const useSubmitTicketRating = (ticketId: number) =>
    useMutationWithHandler(
        {
            mutationFn: (payload: SubmitRatingPayload) =>
                submitTicketRating(ticketId, payload),
        },
        {
            successMessage: 'rating:toast.submit_success',
            reactQueryKeys: [
                QUERY_KEYS.RATINGS_TICKET,
                QUERY_KEYS.RATINGS_AWAITING,
                QUERY_KEYS.RATINGS_RECEIVED,
            ],
        }
    )

// Tab "Điểm của tôi" — đánh giá tôi nhận được.
//
// filters PHẢI nằm trong queryKey, nếu không TanStack sẽ trả cache của bộ lọc trước.
// Key vẫn bắt đầu bằng RATINGS_RECEIVED nên invalidate sau khi submit (so khớp theo
// substring của key đã join) vẫn phủ mọi tổ hợp filter.
// placeholderData giữ dữ liệu cũ trong lúc fetch -> đổi filter/trang không bị nháy trắng.
export const useMyReceivedRatings = (
    page: number,
    pageSize = 20,
    filters: ReceivedRatingFilters = {}
) =>
    useQueryWithHandler({
        queryKey: [
            QUERY_KEYS.RATINGS_RECEIVED,
            page,
            pageSize,
            JSON.stringify(filters),
        ],
        queryFn: () => getMyReceivedRatings(page, pageSize, filters),
        placeholderData: true,
    })

// Tab "Chờ tôi đánh giá".
export const useAwaitingRatings = (
    page: number,
    pageSize = 20,
    filters: AwaitingRatingFilters = {}
) =>
    useQueryWithHandler({
        queryKey: [
            QUERY_KEYS.RATINGS_AWAITING,
            page,
            pageSize,
            JSON.stringify(filters),
        ],
        queryFn: () => getAwaitingRatings(page, pageSize, filters),
        placeholderData: true,
    })
